<div class="mat-elevation-z8">
  <div class="filter-actions-line">
    <!-- <app-select-search (selectedItemId)="onMarketReceived($event)" [selectItems]="selectMarketItems"
      selectTitle="Market"></app-select-search> -->

    <app-select-search (selectedItemId)="onSiteReceived($event)" [selectItems]="selectSiteItems"
      selectTitle="Sites"></app-select-search>
      
    <app-select-search (selectedItemId)="onStatusReceived($event)" [selectItems]="selectStatusItems"
      selectTitle="Status"></app-select-search>

    <app-select-search (selectedItemId)="onDirectionReceived($event)" [selectItems]="directionData" selectTitle="Direction">        
    </app-select-search>

    <mat-form-field appearance="outline" style="width: 9%">
      <mat-label>Load Type</mat-label>
      <mat-select [(value)]="selectedLoadType">
        <mat-option *ngFor="let option of loadTypesOptions" [value]="option.value">
          {{ option.label }}
        </mat-option>
      </mat-select>
    </mat-form-field>

    <mat-form-field appearance="outline" style="width:230px">
      <mat-label>Enter a date range</mat-label>
      <mat-date-range-input id="dtRange" data-testid="dtRange" [formGroup]="range" [rangePicker]="picker"  [min]="minDate">
        <input matStartDate id="startDateInput" placeholder="Start date" formControlName="start" (blur)="dateformat($event)" (keydown)="onKeydown($event)">
        <input matEndDate id="endDateInput" placeholder="End date" formControlName="end" (blur)="dateformat($event)" (keydown)="onKeydown($event)">
      </mat-date-range-input>
      <mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
      <mat-date-range-picker #picker></mat-date-range-picker>
    </mat-form-field>

    <button id="feedStockSearchButton" data-testid="feedStockSearchButton" mat-raised-button color="primary"
      (click)="onSearch()">
      <mat-icon>search</mat-icon>Search
    </button>

    <div class="custom-search-box" style="width:260px">
      <mat-icon>search</mat-icon>
      <input matInput (keyup)="applyFilter($event)" data-testid="txtsearch" placeholder="Search...">
    </div>

    <button mat-icon-button [matMenuTriggerFor]="mainMenu" aria-label="Main Actions Menu">
      <mat-icon>more_vert</mat-icon>
    </button>
    <mat-menu #mainMenu="matMenu">
      @if(this.userroles.includes("DRV")){
        <button mat-menu-item id="btnol" data-testid="btnol" (click)="CreateouboundDialog(0, 'Add', null)">
          <mat-icon>add</mat-icon>
          <span>Create BOL</span>
        </button>
        <button mat-menu-item id="btnol" data-testid="btnol" (click)="CreateInboundDialog(0, 'Add', null)">
          <mat-icon>add</mat-icon>
          <span>Create Pickup</span>
        </button>
      }
      @else{
        <button mat-menu-item id="btnol" data-testid="btnol" (click)="CreateouboundDialog(0, 'Add', null)">
          <mat-icon>add</mat-icon>
          <span>Add Outbound Load</span>
        </button>
        <button mat-menu-item id="btnAddLoad" data-testid="btnAddLoad" (click)="onOpenLoadDialog(0, 'Add')">
          <mat-icon>add</mat-icon>
          <span>Add Inbound Load</span>
        </button>
      }
    </mat-menu>
  </div>
</div>
<div class="mat-elevation-z8 mar-top-20">
  <mat-card>
    <mat-card-content>
      <div class="gridheight mat-elevation-z8 viewport table-container">
        <table mat-table [dataSource]="dataSource" multiTemplateDataRows matSort>
         
          <ng-container matColumnDef="workOrderNumber" sticky>
            <th mat-header-cell *matHeaderCellDef mat-sort-header> Work Order # </th>
            <td mat-cell *matCellDef="let element"> {{element.workOrderNumber}} </td>
          </ng-container>

           <ng-container matColumnDef="date" sticky>
            <th mat-header-cell *matHeaderCellDef mat-sort-header> Service Date </th>
            <td mat-cell *matCellDef="let element"> {{ element.date | date }} </td>
          </ng-container>

          <ng-container matColumnDef="direction" sticky>
            <th mat-header-cell *matHeaderCellDef mat-sort-header> Direction </th>
            <td mat-cell *matCellDef="let element"> {{ element.direction ? 'Outbound' : 'Inbound' }} </td>
          </ng-container>

          <ng-container matColumnDef="status">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>Status</th>
            <td mat-cell *matCellDef="let element"> {{element.status}} </td>            
          </ng-container>

          <ng-container matColumnDef="loadType">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>Load Type</th>
            <td mat-cell *matCellDef="let element"> {{element.loadType}} </td>            
          </ng-container>

          @if(userroles.includes('DRV')){
            <ng-container matColumnDef="destination">
              <th mat-header-cell *matHeaderCellDef mat-sort-header>Destination</th>
              <td mat-cell *matCellDef="let element">{{ element.destination }}</td>
            </ng-container>
          }
          @else{
            <ng-container matColumnDef="source">
              <th mat-header-cell *matHeaderCellDef mat-sort-header>Customer</th>
              <td mat-cell *matCellDef="let element">{{ element.source }}</td>
            </ng-container>
          }
          <ng-container matColumnDef="location">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>Location</th>
            <td mat-cell *matCellDef="let element">{{ element.location }}</td>
          </ng-container>

          <ng-container matColumnDef="bol">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>BOL</th>
            <td mat-cell *matCellDef="let element">{{ element.bol }}</td>
          </ng-container>

          <ng-container matColumnDef="seal">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>SEAL</th>
            <td mat-cell *matCellDef="let element">{{ element.seal }}</td>
          </ng-container>
          <ng-container matColumnDef="purchaseOrderNo">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>Customer PO</th>
            <td mat-cell *matCellDef="let element">{{ element.purchaseOrderNo }}</td>
          </ng-container>
          <ng-container matColumnDef="driver">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>Driver</th>
            <td mat-cell *matCellDef="let element">{{ element.driver }}</td>
          </ng-container>
          <ng-container matColumnDef="pickup">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>Pickup</th>
            <td mat-cell *matCellDef="let element">{{ element.pickup }}</td>
          </ng-container>
          <ng-container matColumnDef="release">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>Release</th>
            <td mat-cell *matCellDef="let element">{{ element.release }}</td>
          </ng-container>
          <ng-container matColumnDef="carrierName">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>Hauler</th>
            <td mat-cell *matCellDef="let element">{{ element.carrierName }}</td>
          </ng-container>
          <ng-container matColumnDef="weightConfirmationYN">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>Weight<br/>Configuration Y/N</th>
            <td mat-cell *matCellDef="let element">{{ element.weightConfirmationYN }}</td>
          </ng-container>
          <ng-container matColumnDef="actions" sticky>
            <th mat-header-cell *matHeaderCellDef>Actions</th>
            <td mat-cell *matCellDef="let row">
              @if(this.userroles.includes("DRV")){
              <div>
                <button mat-icon-button class="icon-btn edit-icon" (click)="onEditOutboundOrInbound(row.id, 'Edit', row.direction, row)">
                  <mat-icon matListIcon>edit</mat-icon>
                </button>
                <button mat-icon-button (click)="onDeleteLoad(row.id, row.workOrderNumber)"
                        style="color: red;">
                  <mat-icon matListIcon color="warn">delete</mat-icon>
                </button>
              </div>
              }
              @else {
              <button mat-icon-button [matMenuTriggerFor]="menu" #menuTrigger="matMenuTrigger"
                      (click)="loadMenuDataAndOpen(row, menuTrigger)">
                <mat-icon>more_vert</mat-icon>
              </button>
              <mat-icon [style.visibility]="row.loadSlip > 0 ? 'visible' : 'hidden'" (click)="openViewDocsDialog(row.id, row.workOrderNumber, row)">attach_file_add</mat-icon>
              <mat-menu #menu="matMenu">
                <button mat-menu-item (click)="onDeleteLoad(row.id, row.workOrderNumber)"
                        style="color: red;">
                  <mat-icon matListIcon color="warn">delete</mat-icon>
                  <span matLine>Delete Load</span>
                </button>
                <button (click)="openEditDeepakDialog(row.direction, row.id, 'Duplicate', row)" mat-menu-item [disabled]="row.adsFlag">
                  <mat-icon matListIcon>content_copy</mat-icon>
                  <span matLine>Duplicate Load</span>
                </button>
                <button mat-menu-item (click)="openEditDeepakDialog(row.direction, row.id, 'Edit', row)" [disabled]="row.adsFlag">
                  <mat-icon matListIcon>edit</mat-icon>
                  <span matLine>Edit</span>
                </button>
                <button mat-menu-item [disabled]="row.adsFlag"
                        (click)="addRevenue(row.id, row.workOrderNumber, row.statusDescription)"
                        [ngClass]="getIconBgClass(row)">
                  <mat-icon matListIcon>attach_money</mat-icon>
                  <span matLine>Additional Info</span>
                </button>
                <button mat-menu-item [disabled]="row.adsFlag"
                        (click)="openAttachDocuments(row.id, row.workOrderNumber)">
                  <mat-icon matListIcon>attach_file_add</mat-icon>
                  <span matLine>Attach docs</span>
                </button>
                <button mat-menu-item [disabled]="row.menuData?.loadSlip == 0"
                        [ngClass]="{ iconBGColor: row.menuData?.loadSlip > 0 }"
                        (click)="openViewDocsDialog(row.id, row.workOrderNumber, row)">
                  <mat-icon matListIcon>visibility</mat-icon>
                  <span matLine>View docs</span>
                </button>
              </mat-menu>
              }
            </td>
          </ng-container>

          <tr mat-header-row *matHeaderRowDef="displayedColumns(); sticky: true"></tr>
          <tr mat-row *matRowDef="let row; columns: displayedColumns();"></tr>
          <tr class="mat-row" *matNoDataRow>
            <td class="mat-cell" [attr.colspan]="displayedColumns().length">No data matching the filter.</td>
          </tr>
        </table>
      </div>
    </mat-card-content>
  </mat-card>
</div>
